var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgPf = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M0 85.337h512v341.326H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 85.337h512v113.775H0zm0 227.551h512v113.775H0z",
  fill: "#d80027"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M293.991 256c0 20.982-17.01 33.243-37.992 33.243S218.008 276.982 218.008 256s17.01-37.992 37.992-37.992 37.991 17.01 37.991 37.992z",
  fill: "#ffda44"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M293.991 256c0 20.982-17.01 37.992-37.992 37.992s-37.992-17.01-37.992-37.992",
  fill: "#0052b4"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M232.259 246.506h9.498v19h-9.498zm37.988 0h9.498v19h-9.498zm-19-14.247h9.498v33.243h-9.498z",
  fill: "#d80027"
})));

export default SvgPf;